import { Footer } from '@/components/footer';
import { Nav } from '@/components/nav';
import { PropsWithChildren, useEffect } from 'react';

interface AppLayoutProps extends PropsWithChildren {
    title?: string;
}

const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    name: 'HM Harmonie Media GmbH',
    image: 'http://harmoniemedia.de/images/Harmonie-Media-Logo.svg',
    '@id': '',
    url: 'https://www.harmoniemedia.de',
    telephone: '06162-9899176',
    priceRange: 'low',
    address: {
        '@type': 'PostalAddress',
        streetAddress: 'Wilhelmstraße 30',
        addressLocality: 'Reinheim',
        postalCode: '64354',
        addressCountry: 'DE',
    },
    geo: {
        '@type': 'GeoCoordinates',
        latitude: 49.83041861391169,
        longitude: 8.830846654561434,
    },
    openingHoursSpecification: {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
        opens: '00:00',
        closes: '23:59',
    },
};

export function AppLayout({ children, title }: AppLayoutProps) {
    const pageTitle = title ? `${title} - Harmonie Media` : 'Harmonie Media - Software-Entwicklung & Prozess-Optimierung';

    useEffect(() => {
        // Set document title
        document.title = pageTitle;

        // Set meta description if not already set
        let metaDescription = document.querySelector('meta[name="description"]');
        if (!metaDescription) {
            metaDescription = document.createElement('meta');
            metaDescription.setAttribute('name', 'description');
            metaDescription.setAttribute(
                'content',
                'Experten für Software-Entwicklung ✓ Web-Apps ✓ Prozess-Optimierung ✓ UI ✓ UX ✓ SEO ✓ Design-Trends ✓ Programmierung ✓',
            );
            document.head.appendChild(metaDescription);
        }

        // Add JSON-LD structured data
        let existingScript = document.querySelector('script[type="application/ld+json"]');
        if (!existingScript) {
            const script = document.createElement('script');
            script.type = 'application/ld+json';
            script.textContent = JSON.stringify(jsonLd);
            document.head.appendChild(script);
        }
    }, [pageTitle]);

    return (
        <>
            <Nav />
            <main className="min-h-screen bg-zinc-950 text-slate-100 antialiased">{children}</main>
            <Footer />
        </>
    );
}
